import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, stateEnum } from "../constants/enum.js"
import customAPI from "../api/customAPI.js"

export const setChallanReportDetail = createAsyncThunk(
  "sale/fetchChallanDetail",
  async ({ token, compcode, itemcode, acid, chalno, billno, billtype, tradeof, ismanualentry, dbuser }) => {

    try {
      console.log(chalno)
      const { data } = await customAPI.post(
        apiRoute.transaction.SaleEntry.challanPrint,
        {
          compcode: compcode,
          ac_id: acid,
          bill_no: billno,
          chal_no: chalno,
          item_code: itemcode,
          bill_type: billtype,
          ismanual_entry: 0,
          trade_of: tradeof,
          db_user: dbuser,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )

      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)


const { saleEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
  rptChallanData: []

}


const saleEntrySlice = createSlice({
  name: saleEntry,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(setChallanReportDetail.fulfilled, (state, action) => {
        state.rptChallanData = action.payload
      })
      .addCase(setChallanReportDetail.rejected, (state, action) => {
        state.rptChallanData = []
      })
  },
  reducers: {

    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
    resetChallanReportData: (state) => {
      state.rptChallanData = []
    },
  },

})

export const { setDetailParams, resetDetailParams, setNewEntryMode ,resetChallanReportData} = saleEntrySlice.actions
export default saleEntrySlice.reducer
